module.exports = __webpack_public_path__ + "media/images/ticket/navi_digital_ticket-8ba3562ad52b48446cff045b373e1531.png";